import { render, staticRenderFns } from "./SMTPConfiguration.vue?vue&type=template&id=5f2eea9c&scoped=true"
import script from "./SMTPConfiguration.vue?vue&type=script&lang=js"
export * from "./SMTPConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2eea9c",
  null
  
)

export default component.exports